import React from "react";

export default class LearningPlanAssessments extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      assessments: this.props.assessments || [],
    };
  }

  componentDidMount() {
    var self = this;

    $(window).on("assessmentCompleted", function (e, data) {
      //console.log('LearningPlanAssessments assessmentCompleted', data);
      self.setState({ assessments: data.assessments });
    });
  }

  render() {
    console.log("LearningPlanAssessments", this.props);

    return (
      <div className="LearningPlanAssessments">
        <div className="panel panel-default">
          <div className="panel-body text-center">
            <div className="assessment-section">
              <h4>Final Exam</h4>
              {this.renderButton("summary", "final exam")}
            </div>

            <div className="assessment-section">
              <h4>Follow-Up Checkup</h4>
              {this.renderButton("fitness", "follow-up checkup")}
            </div>

            <div className="assessment-section">
              <h4>Survey</h4>
              {this.renderButton("survey", "survey")}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderButton(format, name) {
    var assessment = this.getAssessmentByFormat(format);

    if (assessment.locked) {
      return (
        <div className="locked">
          <span className="fa fa-lock"></span> Locked
        </div>
      );
    } else {
      return (
        <a href={assessment.url} className="btn btn-primary modal-link">
          Take {name}
        </a>
      );
    }
  }

  /**
   * Helper functions
   */
  getAssessmentByFormat(format) {
    for (var i = 0, ilen = this.state.assessments.length; i < ilen; i++) {
      if (this.state.assessments[i].format == format) {
        return this.state.assessments[i];
      }
    }
  }
}
